import { useCallback, useEffect, useState } from 'react';

export function useGridColumnCount(ref: React.RefObject<HTMLDivElement>) {
	const [columnCount, setColumnCount] = useState(0);

	const calculateColumnCount = useCallback((el?: HTMLDivElement) => {
		if (!el) return;
		const computed = window.getComputedStyle(el);
		const count = computed.getPropertyValue('grid-template-columns').split(' ').length;
		setColumnCount(count);
	}, []);

	useEffect(() => {
		if (!ref.current) {
			return () => {};
		}
		calculateColumnCount(ref.current);
		const resizeObserver = new ResizeObserver(() => {
			calculateColumnCount(ref.current);
		});
		resizeObserver.observe(ref.current);
		return () => { resizeObserver.disconnect(); };
	}, [calculateColumnCount, ref]);

	return columnCount;
} 